initButtons();

function initButtons() {
  const container = document.querySelector(".baby-registry-landing__buttons");
  if (!container) return;

  const isLoggedIn = container.dataset.loggedIn === "true";
  const anchors = container.querySelectorAll("a");
  if (!anchors.length) return;

  if (!isLoggedIn) {
    anchors.forEach((anchor) => {
      anchor.addEventListener("click", (e) => {
        e.preventDefault();
        sessionStorage.setItem("redirect-path", location.pathname);
        openOtpLoginPopup(e, "verify-customer-id");
      });
    });
  }
}
